import { fetcher } from 'services/helpers/responseHandler'
import { isRunningInElectron } from 'utils/envHelpers'

const isRunningAsElectron = isRunningInElectron()

const google = async ({ GoogleIdToken, geoLocation = {} }) =>
  await fetcher.post(`login/login-google${isRunningAsElectron ? '?lang=en' : ''}`, {
    GoogleIdToken,
    geoLocation,
    ScreenResolution: isRunningAsElectron
      ? `electronResolution`
      : `${window.screen.width}x${window.screen.height}`
  })

const microsoft = async ({ MicrosoftIdToken, geoLocation = {} }) =>
  await fetcher.post(`login/login-microsoft${isRunningAsElectron ? '?lang=en' : ''}`, {
    MicrosoftIdToken,
    geoLocation,
    ScreenResolution: isRunningAsElectron
      ? `electronResolution`
      : `${window.screen.width}x${window.screen.height}`
  })

const socialLoginApi = {
  google,
  microsoft
}

export default socialLoginApi
